import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { UserSessionService } from "src/app/services/usersession.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { VehicleService } from "src/app/services/vehicle.service";
import swal from "sweetalert2";
import * as moment from "moment";
import { AttachmentType } from "src/enum/attachmentType.enum";
import { FileType } from "src/enum/fileType.enum";
import { EventType } from "src/enum/eventtype";
import { TranslateService } from "@ngx-translate/core";
import { AlertService } from "src/app/services/alert.service";
import * as _ from "lodash";
import { result } from "lodash";
import { Router } from "@angular/router";
import { Location } from '@angular/common';
import { LoaderService } from "src/app/services/loader.service";
import { SharedImageService } from 'src/app/services/shared-image.service'; // adjust path if needed

@Component({
  selector: "app-send-back-dialog",
  templateUrl: "./send-back-dialog.component.html",
  styleUrls: ["./send-back-dialog.component.scss"],
})
export class SendBackDialogComponent implements OnInit {
  actionInfo: number;
  item: any;
  selectedFileName: string = '';
  id: number;
  form: FormGroup;
  stage: any[] = [];
  filterclassificationVal: any[];
  filterStage: any[];
  compVal: any[] = [];
  filtercompVal: any[];
  eventType: any[];
  loading: boolean;
  eventTypeList: any;
  file: any;
  dateWithTime: string;
  FileExtention2: any;
  BannerImage2: File;
  userImageBase642: string | null = null;
  url: string | null = null;
  fileTypeEnum = FileType;
  attachmentData: any[] = [];
  attachmentType = AttachmentType;
  data: any;
  isLoading: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<SendBackDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    public addServiceDialog: MatDialog,
    private userSessionService: UserSessionService,
    private formBuilder: FormBuilder,
    private vehicleService: VehicleService,
    private translate: TranslateService,
    private alertService: AlertService,
    private loaderService: LoaderService,
    private location: Location,
    private sharedImageService: SharedImageService
  ) {
  
  }
  selectedFile: File | null = null;

selectFile(event: Event): void {
  this.form.controls["image"].markAsTouched();

  const input = event.target as HTMLInputElement;
  const files: FileList | null = input.files;

  if (!files || files.length === 0) {
    swal.fire("Warning", "Please upload a file", "warning");
    return;
  }

  const file: File = files[0];
  this.selectedFileName = file.name;
  this.selectedFile = file;
  const fileName = file.name;
  const fileExtension = fileName.split(".").pop()?.toLowerCase() || '';
  const allowedTypes = ["png", "jpeg", "jpg", "pdf", "doc"];
  const isValidType = allowedTypes.includes(fileExtension);

  if (!isValidType) {
    swal.fire("Warning", "Allowed formats: PNG, JPEG, JPG, PDF, DOC", "warning");
    return;
  }

  if (file.size > 2 * 1024 * 1024) {
    swal.fire("Warning", "The file can't be larger than 2MB", "warning");
    return;
  }

  const index = this.attachmentData.findIndex(v => v.attachmentFilename === fileName);
  if (index !== -1) {
    this.attachmentData.splice(index, 1);
  }

  const reader = new FileReader();
  reader.onloadend = () => {
    const base64 = (reader.result as string).split(',')[1];
    const fileType = fileExtension === 'pdf' ? this.fileTypeEnum.Pdf : this.fileTypeEnum.Image;

    this.attachmentData.push({
      id: 0,
      base64String: base64,
      attachmentFilename: fileName,
      fileType: fileType,
      attachmentType: this.dataRecievedData.id === 2
        ? this.attachmentType.AdminBookingCancel
        : this.attachmentType.AdminBookingSenback
    });

    this.form.controls["image"].setValue(fileName);
  };

  reader.onerror = () => {
    swal.fire("Error", "Failed to read file", "error");
  };

  reader.readAsDataURL(file);
}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      image: ["", Validators.required ],
      remarks: ["", Validators.required],
      stage: [null, this.dataRecievedData.id == 1 ? Validators.required : []],
    });
    // Send-back targets depend on the booking's current status, so always fetch them fresh for it.
    if (this.dataRecievedData.id == 1) {
      this.stagesLookup(this.dataRecievedData.eventType);
    }
  }
  // The API returns the stages this booking can be sent back to (order and names already set).
  stagesLookup(eventType: any) {
    this.isLoading = true;
    this.vehicleService.getStageLookupData(eventType, this.dataRecievedData.isPlacedAtDealerPremises, true).subscribe((res) => {
      this.stage = (res || []).map((s: any) =>
        s.key == EventType.PreInspectionbyAE ? { ...s, value: 'Waiting for Dealer Selection' } : s);
      this.filterStage = this.stage;
      if (this.stage.length === 1) {
        this.form.controls["stage"].setValue(this.stage[0].key);
      }
      this.isLoading = false;
    });
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched(); // Trigger validation messages
      return; // Don't close the dialog
    }
    if (this.form.valid) {
      this.loaderService.show();

      const formattedAttachments = this.attachmentData.map(file => ({
        id: 0,
        attachmentFilename: file.attachmentFilename,
        attachmentType: file.attachmentType,
        fileType: file.fileType,
        base64String: file.base64String
      }));

      let data = {
        id: this.dataRecievedData.userId,
        remarks: this.form.value.remarks,
        eventType: this.dataRecievedData.id==1? this.form.value.stage:27,
        attachment: formattedAttachments,
      };

      this.vehicleService.saveSendBackCancel(data).subscribe((res) => {
        if (res && res.isSuccess) {
          const msg1 = this.translate.instant("Cancel successfully");
          const msg2 = this.translate.instant("successfully Sendback");
          const sucessmsg = this.dataRecievedData.id == 2 ? msg1 : msg2;
          this.alertService.success(this.dataRecievedData.id == 2 ? "Cancel successfully" : "successfully Sendback");
          const firstAttachment = this.attachmentData[0];
        if (firstAttachment) {
          this.sharedImageService.setImage({
            filename: firstAttachment.attachmentFilename,
            base64: firstAttachment.base64String
          });
        }
          this.dialogRef.close(true);
this.loading=true;
        }

      });
    } else {
      this.form.markAllAsTouched();
    }
  }

}
